module.exports = __webpack_public_path__ + "static/media/josue_mejia_rata.337a30c0.png";